'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var _rollupPluginBabelHelpers = require('../../../../_virtual/_rollupPluginBabelHelpers.js');
var React = require('react');
var React__default = _interopDefault(React);
var PropTypes = _interopDefault(require('prop-types'));
var classNames = _interopDefault(require('classnames/dedupe'));
var Icon = require('../../01.atoms/Icon/Icon.js');
var MaterialDrop = require('../../01.atoms/MaterialDrop/MaterialDrop.js');
require('./_index.scss.js');

var CLASSNAME = 'varta-slider',
    cnWrapperLabels = "".concat(CLASSNAME, "__wrapper-labels"),
    cnWrapperButton = "".concat(CLASSNAME, "__wrapper-button"),
    cnLabel = "".concat(CLASSNAME, "__label"),
    cnLabelSliding = "".concat(cnLabel, " ").concat(cnLabel, "--sliding"),
    cnLabelActive = "".concat(cnLabel, "--active"),
    cnLabelTitle = "".concat(cnLabel, "__title"),
    cnWrapper = "".concat(CLASSNAME, "__wrapper"),
    cnWrapperRange = "".concat(CLASSNAME, "__wrapper-range"),
    cnWrapperRangeProgress = "".concat(cnWrapperRange, "__progress"),
    cnRange = "".concat(CLASSNAME, "__range"),
    cnThumb = "".concat(CLASSNAME, "__thumb"),
    cnButton = "".concat(CLASSNAME, "__button"),
    cnLegend = "".concat(CLASSNAME, "__legend"),
    cnIcon = "".concat(CLASSNAME, "__icon"),
    cnButtonNext = "".concat(cnButton, " ").concat(cnButton, "--next"),
    cnButtonPrev = "".concat(cnButton, " ").concat(cnButton, "--prev"),
    cnMore = "".concat(cnLabel, "__more");
/**
 * 
 */

var Slider = /*#__PURE__*/function (_React$Component) {
  _rollupPluginBabelHelpers.inherits(Slider, _React$Component);

  var _super = _rollupPluginBabelHelpers.createSuper(Slider);

  function Slider() {
    var _this;

    _rollupPluginBabelHelpers.classCallCheck(this, Slider);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _rollupPluginBabelHelpers.defineProperty(_rollupPluginBabelHelpers.assertThisInitialized(_this), "onInput", function (e) {
      var onChange = _this.props.onChange;

      _this.setState({
        value: e.target.value - 0
      });

      onChange(e.target.value - 0);
    });

    _rollupPluginBabelHelpers.defineProperty(_rollupPluginBabelHelpers.assertThisInitialized(_this), "onPrevClick", function () {
      _this.selectNextValue(-1);
    });

    _rollupPluginBabelHelpers.defineProperty(_rollupPluginBabelHelpers.assertThisInitialized(_this), "onNextClick", function () {
      _this.selectNextValue(1);
    });

    var _this$props = _this.props,
        selected = _this$props.selected,
        min = _this$props.min;
    _this.state = {
      value: Math.max(selected, min)
    };
    return _this;
  }

  _rollupPluginBabelHelpers.createClass(Slider, [{
    key: "onLabelClick",
    value: function onLabelClick(value) {
      this.setState({
        value: value
      });
    }
  }, {
    key: "selectNextValue",
    value: function selectNextValue(dir) {
      var _this2 = this;

      var _this$props2 = this.props,
          min = _this$props2.min,
          max = _this$props2.max,
          steps = _this$props2.steps,
          onChange = _this$props2.onChange,
          delta = max - min,
          labelValue = Math.round(delta / (steps - 1));
      this.setState(function (_ref) {
        var value = _ref.value;
        return {
          value: Math.min(Math.max(value + labelValue * dir, 0), max)
        };
      }, function () {
        var value = _this2.state.value;
        onChange(value);
      });
    }
  }, {
    key: "hasEachStepALabel",
    value: function hasEachStepALabel() {
      var _this$props3 = this.props,
          steps = _this$props3.steps,
          step = _this$props3.step,
          min = _this$props3.min,
          max = _this$props3.max,
          delta = max - min;
      return delta / step !== steps - 1;
    }
  }, {
    key: "getLabelName",
    value: function getLabelName(i) {
      var _this3 = this;

      var _this$props4 = this.props,
          steps = _this$props4.steps,
          min = _this$props4.min,
          max = _this$props4.max,
          value = this.state.value,
          delta = max - min,
          labelValue = Math.round(delta / (steps - 1) * i + min),
          active = value === labelValue,
          classes = [cnLabel, active ? cnLabelActive : null];
      return /*#__PURE__*/React__default.createElement("div", {
        key: i,
        className: classNames(classes),
        style: {
          left: "".concat(100 / (steps - 1) * i, "%")
        },
        onMouseDown: function onMouseDown() {
          _this3.onLabelClick(labelValue);
        }
      }, this.getLabelTag(labelValue, i >= steps - 1));
    }
  }, {
    key: "getLabelTag",
    value: function getLabelTag(value, last) {
      var _this$props5 = this.props,
          more = _this$props5.more,
          unit = _this$props5.unit,
          labelRange = _this$props5.labelRange,
          format = _this$props5.format;
      var val = !format ? value : new Intl.NumberFormat(format).format(value);
      var output = "".concat(val);

      if (labelRange && !last) {
        output = "".concat(val + 1, "-").concat(val + labelRange);
      } else if (labelRange) {
        output = "".concat(val + 1);
      }

      output = "".concat(output).concat(unit);

      if ((more || labelRange) && last) {
        return /*#__PURE__*/React__default.createElement("span", {
          className: cnLabelTitle
        }, output, /*#__PURE__*/React__default.createElement("sup", {
          className: cnMore
        }, "+"));
      }

      return /*#__PURE__*/React__default.createElement("span", {
        className: cnLabelTitle
      }, output);
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;

      var _this$props6 = this.props,
          className = _this$props6.className,
          style = _this$props6.style,
          steps = _this$props6.steps,
          min = _this$props6.min,
          max = _this$props6.max,
          step = _this$props6.step,
          iconId = _this$props6.iconId,
          format = _this$props6.format,
          legend = _this$props6.legend,
          mobile = _this$props6.mobile,
          showButtons = _this$props6.showButtons,
          name = _this$props6.name,
          value = this.state.value;
      var progress = (value - min) / (max - min) * 100;
      var labelStyle = {
        left: "".concat(progress, "%")
      },
          labelClasses = [cnLabelActive, cnLabelSliding],
          iconSize = mobile ? 'sm' : 'md';

      if (!this.hasEachStepALabel()) {
        labelClasses.push('hidden-md-up');
      }

      return /*#__PURE__*/React__default.createElement("div", {
        className: classNames(className, CLASSNAME),
        style: style
      }, /*#__PURE__*/React__default.createElement("div", {
        className: cnWrapperButton
      }, legend && /*#__PURE__*/React__default.createElement("span", {
        className: cnLegend
      }, legend), showButtons && !this.hasEachStepALabel() && /*#__PURE__*/React__default.createElement("button", {
        className: cnButtonPrev,
        onClick: this.onPrevClick,
        disabled: value <= min
      }, /*#__PURE__*/React__default.createElement(Icon, {
        id: "caret-left",
        size: "sm"
      }), /*#__PURE__*/React__default.createElement(MaterialDrop, {
        disabled: value <= min
      }))), /*#__PURE__*/React__default.createElement("div", {
        className: cnWrapper
      }, /*#__PURE__*/React__default.createElement("div", {
        className: cnWrapperLabels
      }, _rollupPluginBabelHelpers.toConsumableArray(new Array(steps)).map(function (_, i) {
        return _this4.getLabelName(i);
      })), /*#__PURE__*/React__default.createElement("div", {
        className: classNames(labelClasses),
        style: labelStyle
      }, this.getLabelTag(value, value === max)), /*#__PURE__*/React__default.createElement("div", {
        className: cnThumb,
        style: labelStyle
      }, iconId && [/*#__PURE__*/React__default.createElement(Icon, {
        key: "mobile",
        className: cnIcon,
        id: iconId,
        size: iconSize
      })]), /*#__PURE__*/React__default.createElement("div", {
        className: cnWrapperRange
      }, /*#__PURE__*/React__default.createElement("input", {
        className: cnRange,
        type: "range",
        min: min,
        max: max,
        step: step,
        value: !format ? value : new Intl.NumberFormat(format).format(value),
        onInput: this.onInput,
        onChange: this.onInput,
        name: name
      }), /*#__PURE__*/React__default.createElement("div", {
        className: cnWrapperRangeProgress,
        style: {
          right: "".concat(100 - progress, "%")
        }
      }))), /*#__PURE__*/React__default.createElement("div", {
        className: cnWrapperButton
      }, showButtons && !this.hasEachStepALabel() && /*#__PURE__*/React__default.createElement("button", {
        className: cnButtonNext,
        onClick: this.onNextClick,
        disabled: value >= max
      }, /*#__PURE__*/React__default.createElement(Icon, {
        id: "caret-right",
        size: "sm"
      }), /*#__PURE__*/React__default.createElement(MaterialDrop, {
        disabled: value >= max
      }))));
    }
  }]);

  return Slider;
}(React__default.Component);
Slider.propTypes = {
  /** Additional class name */
  className: PropTypes.string,

  /** */
  format: PropTypes.string,

  /** Id of icon on slider */
  iconId: PropTypes.string,

  /** Range for labels */
  labelRange: PropTypes.number,

  /** Short description for values */
  legend: PropTypes.string,

  /** Max value */
  max: PropTypes.number,

  /** Min value */
  min: PropTypes.number,

  /** True for mobile styling */
  mobile: PropTypes.bool,

  /** True for + sign at max value */
  more: PropTypes.bool,

  /** Name in form */
  name: PropTypes.string,

  /** Callback function */
  onChange: PropTypes.func,

  /** Selected number */
  selected: PropTypes.number,

  /** True to display buttons */
  showButtons: PropTypes.bool,

  /** Number of steps in labels */
  steps: PropTypes.number,

  /** Size of step on slide */
  step: PropTypes.number,

  /** Addtional style object */
  style: PropTypes.object,

  /** Unit of values */
  unit: PropTypes.string
};
Slider.defaultProps = {
  max: 100,
  min: 0,
  onChange: function onChange() {
    return void 0;
  },
  selected: 0,
  steps: 2,
  step: 1,
  unit: ''
};

module.exports = Slider;
